<template lang="pug">
  // Left div because b-navbar does not trigger on mouseenter / mouseleave events
  .sidenav.navbar.navbar-vertical.fixed-left.navbar-expand-xs.navbar-light.bg-white(@mouseenter='$sidebar.onMouseEnter()' @mouseleave='$sidebar.onMouseLeave()' :data='backgroundColor')
    .scrollbar-inner(ref='sidebarScrollArea')
      .sidenav-header.d-flex.align-items-center
        b-navbar-brand(href='#')
          .d-flex.align-items-center
            b.mr-3 doQument
          
        .ml-auto
          // Sidenav toggler
          .sidenav-toggler.d-none.d-xl-block(:class="{'active': !$sidebar.isMinimized }" @click='minimizeSidebar')
            .sidenav-toggler-inner
              i.sidenav-toggler-line
              i.sidenav-toggler-line
              i.sidenav-toggler-line
      slot
      .navbar-inner
        b-navbar-nav
          slot(name='links')
            sidebar-item(v-for='(link, index) in sidebarLinks' :key='link.name + index' :link='link')
              sidebar-item(v-for='(subLink, index) in link.children' :key='subLink.name + index' :link='subLink')
        slot(name='links-after')

</template>
<script>
export default {
  name: 'sidebar',
  props: {
    title: {
      type: String,
      default: 'Creative Tim',
      description: 'Sidebar title'
    },
    shortTitle: {
      type: String,
      default: 'CT',
      description: 'Sidebar short title'
    },
    logo: {
      type: String,
      default: 'https://demos.creative-tim.com/vue-argon-dashboard-pro/img/brand/green.png',
      description: 'Sidebar app logo'
    },
    backgroundColor: {
      type: String,
      default: 'vue',
      validator: value => {
        let acceptedValues = [
          '',
          'vue',
          'blue',
          'green',
          'orange',
          'red',
          'primary'
        ];
        return acceptedValues.indexOf(value) !== -1;
      },
      description:
        'Sidebar background color (vue|blue|green|orange|red|primary)'
    },
    sidebarLinks: {
      type: Array,
      default: () => [],
      description:
        "List of sidebar links as an array if you don't want to use components for these."
    },
    autoClose: {
      type: Boolean,
      default: true,
      description:
        'Whether sidebar should autoclose on mobile when clicking an item'
    }
  },
  provide() {
    return {
      autoClose: this.autoClose
    };
  },
  methods: {
    minimizeSidebar() {
      if (this.$sidebar) {
        this.$sidebar.toggleMinimize();
      }
    }
  },
  mounted() {
    this.$sidebar.isMinimized = this.$sidebar.breakpoint < window.innerWidth
    this.minimizeSidebar()
  },
  beforeDestroy() {
    if (this.$sidebar.showSidebar) {
      this.$sidebar.showSidebar = false;
    }
  }
};
</script>
